import React from 'react';
import './About.css';

const About = () => {
  return (
    <>
      {/* Page Header Start */}
      <div className="page-header about-page-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>About Us</h2>
            </div>
            <div className="col-12">
              <a href="/">Home</a>
              <a href="/about">About Us</a>
            </div>
          </div>
        </div>
      </div>
      {/* Page Header End */}

      {/* About Start */}
      <div className="about about-modern-page">
        <div className="container">
          <div className="row align-items-center about-hero-row">
            <div className="col-lg-6">
              <div className="about-img">
                <img src="/img/about_us.png" alt="About SSVASS" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="section-header about-section-header">
                <p>Learn About Us</p>
                <h2>SSVASS Enterprises Gems & Jewellery Exhibition</h2>
              </div>
              <div className="about-text">
                <p>
                  SSVASS Gems & Jewellery Exhibition, organized by SSVASS Enterprises, is one of Eastern India's most
                  prestigious and trusted B2B jewellery trade exhibitions. Established under the leadership of Shri Arun
                  Kumar Verma, SSVASS has emerged as a powerful platform connecting jewellery manufacturers,
                  wholesalers, retailers, designers, gemstone traders, machinery suppliers, and industry professionals
                  from across India.
                </p>
                <p>
                  Over the years, SSVASS has played a significant role in promoting business opportunities, networking,
                  innovation, and market expansion within the gems and jewellery sector. The exhibition provides an
                  ideal environment for showcasing new collections, launching innovative products, discovering emerging
                  trends, and building long-term business relationships.
                </p>
                <p>
                  Today, SSVASS stands as a symbol of trust, quality, and excellence in the jewellery exhibition
                  industry, bringing together thousands of trade visitors and exhibitors under one roof.
                </p>
              </div>
              <div className="about-highlight-grid">
                <div>
                  <span>Since</span>
                  <strong>Trusted Exhibition Platform</strong>
                </div>
                <div>
                  <span>Venue</span>
                  <strong>Gyan Bhawan, Patna</strong>
                </div>
              </div>
            </div>
          </div>

          <div className="about-stats-row">
            <div className="about-stat-card">
              <strong>21st</strong>
              <span>Edition</span>
            </div>
            <div className="about-stat-card">
              <strong>3</strong>
              <span>Focused Trade Days</span>
            </div>
            <div className="about-stat-card">
              <strong>10k+</strong>
              <span>Expected Visitors</span>
            </div>
            <div className="about-stat-card">
              <strong>Patna</strong>
              <span>Jewellery Trade Hub</span>
            </div>
          </div>

          <div className="row mt-5 about-purpose-row">
            <div className="col-lg-12">
              <div className="section-header text-center about-section-header">
                <p>Our Vision & Mission</p>
                <h2>What We Stand For</h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="service-item">
                <div className="service-icon">
                  <i className="fas fa-gem"></i>
                </div>
                <div className="service-text">
                  <h3>Our Mission</h3>
                  <ul className="about-mission-list">
                    <li>To provide a world-class business platform for jewellery manufacturers, wholesalers, retailers, and traders.</li>
                    <li>To promote business networking and strategic partnerships across the industry.</li>
                    <li>To showcase emerging trends, technologies, and innovations in jewellery manufacturing.</li>
                    <li>To support the growth of Indian jewellery businesses through market access and brand visibility.</li>
                    <li>To create valuable opportunities for buyers and sellers to connect and grow together.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="service-item">
                <div className="service-icon">
                  <i className="fas fa-crown"></i>
                </div>
                <div className="service-text">
                  <h3>Our Vision</h3>
                  <p>
                    To become India's most influential regional jewellery exhibition platform by fostering innovation,
                    strengthening industry connections, and creating sustainable growth opportunities for the gems and
                    jewellery sector.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-gold-cta">
            <div>
              <span>SSVASS Jewellery Mahotsav 2026</span>
              <h3>Where jewellery businesses meet opportunity.</h3>
            </div>
            <a href="/visitor">Register as Visitor</a>
          </div>
        </div>
      </div>
      {/* About End */}
    </>
  );
};

export default About;
